import React from 'react';
import { RichUtils, EditorState, CompositeDecorator } from 'draft-js';
import { Button, Grid, Paper, Popover } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';

const Link = ({ entityKey, contentState, children }) => {
    const { url } = contentState.getEntity(entityKey).getData();
    return (
        <a className="link" href={url} rel="noopener noreferrer" target="_blank" aria-label={url}>
            {children}
        </a>
    );
};

const findLinkEntities = (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(character => {
        const entityKey = character.getEntity();

        return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
    }, callback);
};

export const promptForLink = (editorState, setShowURLInput, setUrlValue) => {
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
        const contentState = editorState.getCurrentContent();
        const startKey = editorState.getSelection().getStartKey();
        const startOffset = editorState.getSelection().getStartOffset();
        const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
        const linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);
        let url = '';
        if (linkKey) {
            const linkInstance = contentState.getEntity(linkKey);
            url = linkInstance.getData().url;
        }
        setShowURLInput(true);
        setUrlValue(url);
    }
};

export const confirmLink = (
    editorState,
    urlValue,
    setEditorState,
    setShowURLInput,
    setUrlValue
) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity('LINK', 'MUTABLE', { url: urlValue });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

    // Apply entity
    let nextEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });

    // Apply selection
    nextEditorState = RichUtils.toggleLink(
        nextEditorState,
        nextEditorState.getSelection(),
        entityKey
    );

    setEditorState(nextEditorState);
    setShowURLInput(false);
    setUrlValue('');
};

export const removeLink = (editorState, setEditorState) => {
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
        setEditorState(RichUtils.toggleLink(editorState, selection, null));
    }
};

export const createLinkDecorator = () =>
    new CompositeDecorator([
        {
            strategy: findLinkEntities,
            component: Link
        }
    ]);

export const LinkPopover = ({
    linkRef,
    urlValue,
    setUrlValue,
    editorState,
    setFilteredEditorState,
    setShowURLInput
}) => {
    return (
        <Popover
            open
            anchorEl={linkRef.current}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
        >
            <Paper className="padded">
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label="Url"
                            type="text"
                            fullWidth
                            value={urlValue}
                            onChange={event => setUrlValue(event.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            color="primary"
                            variant="contained"
                            fullWidth
                            onClick={() =>
                                confirmLink(
                                    editorState,
                                    urlValue,
                                    setFilteredEditorState,
                                    setShowURLInput,
                                    setUrlValue
                                )
                            }
                        >
                            Confirm
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </Popover>
    );
};

export const LinkPlugin = {
    decorators: [
        {
            strategy: findLinkEntities,
            component: Link
        }
    ]
};

export default LinkPlugin;
